import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';
import {debounce} from '../../../utils/debounce';

export default function categoryScroll($element) {
    const $nav = $element.querySelector('nav');

    $element.classList.add('splide');
    $nav.classList.add('splide__track');
    $nav.firstElementChild.classList.add('splide__list');
    Array.from($nav.firstElementChild.children).forEach($element => $element.classList.add('splide__slide'));

    $element.insertAdjacentHTML(
        'afterbegin',
        `<div class="splide__arrows"><button class="splide__arrow splide__arrow--prev"><span class="icon"><svg title="Previous" role="img" viewBox="0 0 256 512"><path d="M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z" /></svg></span></button><button class="splide__arrow splide__arrow--next"><span class="icon"><svg title="Next" role="img" viewBox="0 0 256 512"><path d="M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z" /></svg></span></button></div>`
    );

    const itemWidth = $nav.firstElementChild.children[0].clientWidth;

    const carousel = new Splide($element, {
        pagination: false,
        perPage: Math.floor($nav.clientWidth / itemWidth)
    }).mount();

    window.addEventListener(
        'resize',
        debounce(() => {
            carousel.options.perPage = Math.floor($nav.clientWidth / itemWidth);
            carousel.refresh();
        }, 200)
    );
}
